<script lang="ts">
export interface PhxsgLoaderProps {
  customClass?: string | null;
  light?: boolean;
  size?: string | null;
}
</script>

<script setup lang="ts">
const { customClass = null, light = false, size = null } = defineProps<PhxsgLoaderProps>();
</script>

<template>
  <div
    :class="[
      'phxsg-loader',
      `phxsg-loader--${light ? 'light' : 'dark'}`,
      size ? `phxsg-loader--${size}` : null,
      customClass,
    ]"
    role="presentation"
  >
    <div class="phxsg-loader__inner" />
  </div>
</template>
